export default "__VITE_ASSET__BZp$jH0J__"